import MainLayout from './MainLayout';
import GameSettings from '../components/Master';

const GameSettingsView = () => {
    return (
        <MainLayout>
            <GameSettings />
        </MainLayout>
    );
};
export default GameSettingsView;
